var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isActive
    ? _c("div", { staticClass: "frb frb-info" }, [
        _c("input", {
          ref: "radio_method",
          attrs: {
            autocomplete: "off",
            type: "radio",
            id: _vm.input_id,
            name: "radio-button",
            value: "pagseguro",
          },
          domProps: { checked: _vm.methodSelected },
          on: { click: _vm.select },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: _vm.input_id } }, [
          _c("div", { staticClass: "card-body" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.showInvoiceFormLink
              ? _c("p", { staticClass: "small mb-1 mt-2" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.onShowInvoiceForm.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$parent.wantReceiveInvoiceMessage) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pix" }, [
      _c("ul", { staticClass: "list-unstyled list-inline" }, [
        _c("li", { staticClass: "list-inline-item" }, [
          _c("img", {
            staticClass: "img-responsive inline-block checkoutcardfirst",
            attrs: {
              src: require("../../../../static/templates/img/loghi_pagamenti/Pix_logo.png"),
              alt: "pix",
              height: "30",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }